import { ipTimeZone } from '@sports/core'
import { useEffect, useState } from 'preact/hooks'

/**
 * The zone kick-off times render in: the visitor's IP zone once the host's
 * Cloudflare trace answers (see ipTimeZone), undefined until then — callers
 * then fall back to the site zone / the viewer's clock.
 */
export function useTimeZone(): string | undefined {
  const [zone, setZone] = useState<string | undefined>(undefined)
  useEffect(() => {
    let live = true
    void ipTimeZone().then((z) => live && setZone(z))
    return () => {
      live = false
    }
  }, [])
  return zone
}
